import { FunctionComponent, memo } from "react";
import Qs from "qs";
import { faGlobeAmericas, faSearch } from "@fortawesome/pro-solid-svg-icons";
import { IProps } from "./spelling-configuration-filters.types";
import { Field, Form, Formik } from "formik";
import { SubmitOnChange } from "@edgetier/components";
import { FieldInline, LabeledField } from "@edgetier/client-components";
import { trimOrNull } from "@edgetier/utilities";
import SelectLanguage from "components-for/filters/select-language";
import { ISpellingConfigurationForm } from "@edgetier/watchtower-types";
import { useHistory } from "react-router";
import "./spelling-configuration-filters.scss";

/**
 * Filters for spelling configuration table
 * @param prop.initialValues    Default filter form values
 */
const SpellingConfigurationFilters: FunctionComponent<IProps> = ({ initialValues, resetPage }) => {
    const { push } = useHistory();

    /**
     * Update the URL with the filter values whenever the filters change.
     * @param filters The filters that have been changed.
     */
    const onChange = (filters: ISpellingConfigurationForm) => {
        const currentParameters = Qs.parse(window.location.search, { ignoreQueryPrefix: true });
        const trimmedFilters = {
            ...filters,
            search: trimOrNull(filters.search),
        };

        const searchParameters = Qs.stringify(
            { ...currentParameters, ...trimmedFilters },
            { arrayFormat: "repeat", skipNulls: true }
        );

        if (typeof resetPage === "function") {
            resetPage();
        }

        push({ search: searchParameters });
    };

    return (
        <Formik<ISpellingConfigurationForm> onSubmit={onChange} initialValues={initialValues}>
            <Form
                className="spelling-configuration__filters"
                role="form"
                autoComplete="off"
                name="spelling-configuration__filters-form"
            >
                <LabeledField label="Search" name="search">
                    <FieldInline icon={faSearch}>
                        <Field id="search" name="search" placeholder="Search&hellip;" type="text" />
                    </FieldInline>
                </LabeledField>
                <LabeledField label="Language" name="languageIsoCode">
                    <FieldInline icon={faGlobeAmericas}>
                        <SelectLanguage isClearable name="languageIsoCode" />
                    </FieldInline>
                </LabeledField>
                <SubmitOnChange />
            </Form>
        </Formik>
    );
};

export default memo(SpellingConfigurationFilters);
